import { SearchCriteria } from './searchCriteria';
import { CodeLibelle } from "./codeLibelle";
import { Statique } from "../utils/statique";
import { AuthenticationService } from '../services/authentication.service';
import { EbUser } from '../classes/user';

export class SearchCriteriaPricingBooking  extends SearchCriteria{

    listTypeDemandePlugin: Array<any>;
    listTypeRegionPlugin: Array<any>;

    listTypeDemande: Array<number>;
    listTypeRegion: Array<number>;

    dateOfGoodsAvailabilityPlugin : String;
    dateOfGoodsAvailability : String;

    listModeTransportPlugin: Array<any>;
    listModeTransport: Array<number>;

    ebExpeditionNum: number;
    // size: number;
    listExpeditionReference: Array<String>;
    expediteurParty: String;
    destinataireParty: String;
    userConnected: EbUser = AuthenticationService.getConnectedUser();

    constructor() {
        super();
        this.listTypeDemande = new Array<number>();
        this.listTypeRegion = new Array<number>();


        this.dateOfGoodsAvailabilityPlugin = null;
        this.dateOfGoodsAvailability = null;

        this.listModeTransport = new Array<number>();
        this.listModeTransportPlugin = new Array<any>();
        this.ebExpeditionNum = null;
        this.listExpeditionReference = new Array<String>();
      this.expediteurParty = null;
      this.destinataireParty = null;
        // this.size = 25;
    }

    constructorCopy(advancedOptions : SearchCriteriaPricingBooking){
        super.constructorCopy(advancedOptions);
      this.listExpeditionReference = advancedOptions.listExpeditionReference;

      // this.size = advancedOptions.size;
        this.listTypeDemandePlugin = advancedOptions.listTypeDemandePlugin;
        this.listTypeRegionPlugin =  advancedOptions.listTypeRegionPlugin;
        this.listModeTransportPlugin = advancedOptions.listModeTransportPlugin;
      this.ebExpeditionNum = advancedOptions.ebExpeditionNum

        advancedOptions.listTypeDemandePlugin.forEach((typeDemande, index) => {
            this.listTypeDemande.push(typeDemande.code);
        });

        if(advancedOptions.listModeTransportPlugin){
            advancedOptions.listModeTransportPlugin.forEach((listModeTransport, index) => {
                this.listModeTransport.push(listModeTransport.code);
            });
        }

        this.dateOfGoodsAvailabilityPlugin = advancedOptions.dateOfGoodsAvailability;
        this.dateOfGoodsAvailability = advancedOptions.dateOfGoodsAvailability;
      this.expediteurParty = advancedOptions.expediteurParty;
      this.destinataireParty = advancedOptions.destinataireParty;

    }

    formatDates() {
        super.formatDates();

        if(this.dateOfGoodsAvailabilityPlugin  != null) this.dateOfGoodsAvailability = Statique.formatDateFromDatePicker(this.dateOfGoodsAvailabilityPlugin);

        return this;
    }

}



// WEBPACK FOOTER //
// ./src/app/utils/SearchCriteriaPricingBooking.ts